(($, Drupal) => {
  Drupal.behaviors.kafCarousel = {
    attach: (context) => {

      let $carouselLayouts = $('.layout--carousel', context);
      if ($carouselLayouts.length === 0) {
        return;
      }

      var kafCarousel = new Swiper('.layout--carousel', {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });

    }
  };

})(jQuery, Drupal);
